/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_content_delivery_bucket": "client-view-20190322154657-hostingbucket-prod",
    "aws_content_delivery_bucket_region": "us-east-2",
    "aws_content_delivery_url": "https://drcezzfmwn33o.cloudfront.net",
    "aws_cognito_identity_pool_id": "us-east-2:68776b07-cfe8-47ca-9268-76aae9347df6",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_3vcaki1ZF",
    "aws_user_pools_web_client_id": "11bqmofh0bvdmrqb77hj2iib3e",
    "oauth": {},
    "aws_dynamodb_all_tables_region": "us-east-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "companies-prod",
            "region": "us-east-2"
        },
        {
            "tableName": "questions-prod",
            "region": "us-east-2"
        },
        {
            "tableName": "portalMessages-prod",
            "region": "us-east-2"
        }
    ],
    "aws_user_files_s3_bucket": "portalcontent-38c0f7664cbdstorageportalcontent-prod",
    "aws_user_files_s3_bucket_region": "us-east-2",
    "aws_cloud_logic_custom": [
        {
            "name": "companies",
            "endpoint": "https://ppic5arlde.execute-api.us-east-2.amazonaws.com/prod",
            "region": "us-east-2"
        },
        {
            "name": "questions",
            "endpoint": "https://svm85zlg0l.execute-api.us-east-2.amazonaws.com/prod",
            "region": "us-east-2"
        },
        {
            "name": "portalCompany",
            "endpoint": "https://mhc1h6xeoa.execute-api.us-east-2.amazonaws.com/prod",
            "region": "us-east-2"
        },
        {
            "name": "portalSearch",
            "endpoint": "https://2audcat15f.execute-api.us-east-2.amazonaws.com/prod",
            "region": "us-east-2"
        }
    ]
};


export default awsmobile;
